import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    color: theme.palette.divider,
    width: '100%',
    margin: '0.5rem auto',
    display: 'flex',
    whiteSpace: 'nowrap',

    '&:before, &:after': {
      content: "' '",
      width: '100%',
      borderBottom: `0.0625rem solid #e3e3e3`,
      margin: '0.705rem'
    }
  }
}))

export default useStyles
